<template>
  <div class="container-fluid">

    <toast ref="toast"></toast>

    <div class="row">
        <work-menu></work-menu>
        <div class="pt-3" :class="{'col-12': $window.isSP, 'col-md-10': $window.isPC}">
            <div class="form-group">
                <label style="margin-left:5px;">年</label>
                <select class="search-select custom-select" name="year" v-model="selectedYear" @change="changeSelected">
                    <option v-for="year in yearList" :key="year" :value="year">
                        {{year}}
                    </option>
                </select>
                <label style="margin-left:5px;">月</label>
                <select class="search-select custom-select" name="month" v-model="selectedMonth" @change="changeSelected">
                    <option v-for="month in 12" :key="month" :value="month">
                        {{month}}
                    </option>
                </select>
                <span style="margin-left:5px;">労働時間単位</span>
                <select class="search-select custom-select" name="interval" v-model="selectedInterval" @change="changeSelected">
                    <option v-for="interval in [0,15,30,60]" :key="interval" :value="interval">
                        {{interval}}
                    </option>
                </select>
                <label>ユーザ</label>
                <select class="search-select custom-select" name="shiftId" v-model="selectedUserId" @change="changeSelected">
                    <option v-for="user in userList" :key="user.userId" :value="user.userId" v-if="!isRetiree(user.deletedAt)">
                        {{user.userName}}
                    </option>
                </select>
                <label>シフト</label>
                <select class="search-select custom-select" name="shiftId" v-model="selectedShiftId" @change="changeSelected">
                    <option value="0">なし</option>
                    <option v-for="shift in shiftList" :key="shift.id" :value="shift.id">
                        {{shift.name}}
                    </option>
                </select>
                <a :href="'/api/work/download/excel/' + selectedYear + '/' + selectedMonth + '/' + selectedUserId + '?interval=' + selectedInterval + '&shiftId=' + selectedShiftId">
                    <button type="button" class="btn btn-info" style="border-radius:50px;">
                        <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>Excel
                    </button>
                </a>
                <a :href="'/api/work/download/pdf/' + selectedYear + '/' + selectedMonth + '/' + selectedUserId + '?interval=' + selectedInterval + '&shiftId=' + selectedShiftId">
                    <button type="button" class="btn btn-info" style="border-radius:50px;">
                        <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>PDF
                    </button>
                </a>

                <a v-if="isExistsUpload === true" :href="'/api/work/timetable/upload/' + selectedYear + '/' + selectedMonth + '/' + selectedUserId">
                        <button type="button" class="btn btn-info" style="border-radius:50px;">
                            <i class="fa fa-paperclip fa-1x" aria-hidden="true"></i>添付
                        </button>
                </a>
                <!-- 添付ファイル -->
                <div class="mt-3">
                    <button v-if="isExistsUpload === true" class="btn btn-sm btn-outline-danger m-1" style="border-radius:50px;" @click.stop="deleteAttachment">
                        <i class="fa fa-trash"></i>
                        添付削除
                    </button>
                    <button v-if="isExistsUpload === false" class="btn btn-sm btn-outline-dark m-1" style="border-radius:50px;" @click.stop="clickShowAttachment">
                        <i class="fa" :class="{'fa-chevron-circle-right': !showAttachment, 'fa-chevron-circle-left': showAttachment}"></i>
                        勤務表アップロード
                    </button>
                    <form v-if="isExistsUpload === false && showAttachment === true" @submit.prevent="upload">
                        <input @change="selectedFile" type="file" name="file" id="uploadFile">
                        <button v-if="uploadFile" type="submit" class="btn btn-info">
                            <i class="fa fa-cloud-upload fa-1x" aria-hidden="true"></i>アップロード
                        </button>
                    </form>
                </div>

            </div>
            <div v-if="workTimetable" class="row">
                <h3 class="col-md-4 pt-1">合計勤務時間 <span>{{workTimetable.workHourSum}}</span></h3>
                <!-- 差し戻し -->
                <div class="ml-3" v-if="workTimetable.confirmCount + workTimetable.remandRequestCount + workTimetable.approvedCount != 0">
                    <button class="btn btn-sm btn-default btn-outline-dark" data-toggle="modal" :data-target="'#remand'">
                        <i class="fa fa-reply fa-1x" aria-hidden="true"></i>差し戻し
                    </button>
                    <!-- Modal -->
                    <div class="modal fade" id="remand" tabindex="-1" role="dialog" aria-labelledby="remandLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="remandLabel">確認</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <p>以下を確認ください</p>
                                    <p>・ユーザは勤怠編集可能になります</p>
                                    <p>・ユーザに通知します</p>
                                    <p>本当に差し戻しますか？</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">キャンセル</button>
                                    <button type="button" class="btn btn-warning" data-dismiss="modal" @click="updateStatus('remand')">差し戻し</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 確定 -->
                <div class="ml-1" v-if="workTimetable.approvedCount < workTimetable.days">
                    <button class="btn btn-sm btn-raised btn-success" data-toggle="modal" :data-target="'#workConfirm'">
                        <i class="fa fa-check fa-1x" aria-hidden="true"></i>承認
                    </button>
                    <!-- Modal -->
                    <div class="modal fade" id="workConfirm" tabindex="-1" role="dialog" aria-labelledby="workConfirmLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="workConfirmLabel">確認</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <p>以下を確認ください</p>
                                    <p>・承認後も差し戻し可能です</p>
                                    <p>・ユーザに通知します</p>
                                    <p>本当に承認してよろしいですか？</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">キャンセル</button>
                                    <button type="button" class="btn btn-success" @click="updateStatus('approved')">承認</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 勤務表 -->
            <div v-if="workList.length == 0"></div>
            <div v-else style="overflow:scroll;">
                <table class="table table-sm table-bordered">
                    <thead class="thead-light">
                    <tr>
                        <th>日付</th>
                        <th>曜日</th>
                        <th @click="highlight('clockIn')">出勤</th>
                        <th @click="highlight('clockOut')">退勤</th>
                        <th @click="highlight('breakTime')">休憩</th>
                        <th @click="highlight('otherBreakTime')">その他休憩</th>
                        <th @click="highlight('midnightBreakTime')">深夜帯休憩</th>
                        <th @click="highlight('fixedTime')">所定内勤務</th>
                        <th @click="highlight('overTime')">所定外勤務</th>
                        <th @click="highlight('midnightTime')">深夜勤務</th>
                        <th @click="highlight('workTime')">合計時間</th>
                        <th>休暇種類</th>
                        <th>勤務形態</th>
                        <th>備考</th>
                        <th>修正履歴</th>
                        <!-- <th>ステータス</th> -->
                        <th>
                            <span v-if="workTimetable.approvedCount == workTimetable.days">ステータス</span>
                            <span v-else-if="workTimetable.confirmCount == workTimetable.days">ステータス</span>
                            <span v-else-if="workTimetable.remandRequestCount == workTimetable.days">ステータス</span>
                            <span v-else >修正</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="result in workList" :key="result.targetDate" :class="{'work-highlight': result.hover}" @mouseover="result.hover = true; $forceUpdate()" @mouseleave="result.hover = false; $forceUpdate()">
                        <td>
                            <span v-if="result.dayOfWeek === '土'" style="color:blue">{{result.targetDate | date}}</span>
                            <span  v-else-if="result.dayOfWeek === '日' || isHoliday(result.targetDate)" style="color:red">{{result.targetDate | date}}</span>
                            <span v-else>{{result.targetDate | date}}</span>
                        </td>
                        <td>
                            <span v-if="result.dayOfWeek === '土'" style="color:blue">{{result.dayOfWeek}}</span>
                            <span v-else-if="result.dayOfWeek === '日' || isHoliday(result.targetDate)" style="color:red">{{result.dayOfWeek}}</span>
                            <span v-else>{{result.dayOfWeek}}</span>
                        </td>
                        <td :class="{'highlight' : config.highlightTimeTableClockIn == 1}">
                            <span v-if="result.dayOff < 2">
                                <span>{{result.clockIn | time}}</span>
                                <span v-if="result.late" class="badge badge-warning" style="color: #555">
                                    <span data-toggle="tooltip" data-placement="top" data-html="true" :title="'シフト開始時刻は' + workTimetable.shiftStartHour + 'です'">
                                        遅刻
                                    </span>
                                </span>
                            </span>
                        </td>
                        <td :class="{'highlight' : config.highlightTimeTableClockOut == 1}">
                            <span v-if="result.dayOff < 2">
                                <span>{{result.clockOut | time}}</span>
                                <span v-if="result.leaveEarly" class="badge badge-info">
                                    <span data-toggle="tooltip" data-placement="top" data-html="true" :title="'シフト終了時刻は' + workTimetable.shiftEndHour + 'です'">
                                        早退
                                    </span>
                                </span>
                            </span>
                        </td>
                        <td :class="{'highlight' : config.highlightTimeTableBreakTime == 1}">
                            <span v-if="result.dayOff < 2 && result.clockIn != null && result.clockOut != null">
                                <span>{{result.breakTime}}</span>
                                <span v-if="(result.officeTimeMin > 360 && result.breakTimeMin < 45)
                                            || (result.officeTimeMin > 480 && result.breakTimeMin < 60)
                                            || (result.sumWorkTimeMin == 0 && result.breakTimeMin > 0)"
                                    class="badge badge-danger">
                                    <span data-toggle="tooltip" data-placement="top" data-html="true"
                                        title="次のいずれかが該当しています。ご確認ください。
                                        (1) 6時間勤務以上で休憩が45分未満
                                        (2) 8時間勤務以上で休憩が60分未満
                                        (3) 勤務時間なしで、休憩あり">
                                        確認
                                    </span>
                                </span>
                            </span>
                        </td>
                        <td :class="{'highlight' : config.highlightTimeTableOtherBreakTime == 1}">
                            <span v-if="result.dayOff < 2 && result.clockIn != null && result.clockOut != null">{{result.otherBreakTime}}</span>
                        </td>
                        <td :class="{'highlight' : config.highlightTimeTableMidnightBreakTime == 1}">
                            <span v-if="result.dayOff < 2 && result.clockIn != null && result.clockOut != null">
                                <span>{{result.midnightBreakTime}}</span>
                                <span v-if="(result.midnightTimeMin == 0 && result.midnightBreakTimeMin > 0)" class="badge badge-danger">
                                    <span data-toggle="tooltip" data-placement="top" data-html="true" 
                                        title="深夜勤務なしで、深夜帯休憩があります。ご確認ください">
                                        確認
                                    </span>
                                </span>
                            </span>
                        </td>
                        <td :class="{'highlight' : config.highlightTimeTableFixedTime == 1}"><span v-if="result.dayOff < 2">{{result.fixedWorkHour}}</span></td>
                        <td :class="{'highlight' : config.highlightTimeTableOverTime == 1}"><span v-if="result.dayOff < 2">{{result.overWorkHour}}</span></td>
                        <td :class="{'highlight' : config.highlightTimeTableMidnightTime == 1}"><span v-if="result.dayOff < 2">{{result.midnightWorkHour}}</span></td>
                        <td :class="{'highlight' : config.highlightTimeTableWorkTime == 1}"><span v-if="result.dayOff < 2">{{result.sumWorkHour}}</span></td>
                        <td class="noflap" style="text-align:center;vertical-align:middle;">
                            <span v-if="result.dayOff == 0"></span>
                            <span v-if="result.dayOff == 1">
                                半休
                                    <span v-if="result.hasLeaveRequest" class="badge badge-danger">
                                    有給
                                    </span>
                            </span>
                            <span v-if="result.dayOff == 2">
                                全休
                                    <span v-if="result.hasLeaveRequest" class="badge badge-danger">
                                    有給
                                    </span>
                            </span>
                            <span v-if="result.dayOff == 3">特別休暇<br>({{result.specialLeaveName}})</span>
                            <span v-if="result.dayOff == 4">代休</span>
                            <span v-if="result.dayOff == 5">その他 諸定休暇</span>
                        </td>
                        <td class="noflap" style="font-size:0.7rem;">{{result.workStyle}}</td>
                        <td class="noflap" style="font-size:0.7rem;">{{result.note}}</td>
                        <!-- 修正履歴 -->
                        <td class="pt-0 pb-0" style="text-align:center;vertical-align:middle;">
                            <span v-if="result.edited == 0"></span>
                            <span v-else-if="1">
                                <button class="btn btn-raised btn-info btn-sm" data-toggle="modal"
                                        :data-target="'#' + result.userId + result.targetDate">履歴</button>
                                <!-- Modal -->
                                <div class="modal fade" :id="result.userId + result.targetDate" tabindex="-1"
                                    role="dialog"
                                    aria-labelledby="exampleModal3Label" aria-hidden="true">
                                    <div class="modal-dialog modal-lg" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="exampleModal3Label">
                                                   {{result.targetDate}}の編集履歴
                                                </h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <table class="table table-bordered table-responsive">
                                                    <thead class="thead-light">
                                                    <tr>
                                                        <th>更新日時</th>
                                                        <th>更新者</th>
                                                        <th>出勤</th>
                                                        <th>退勤</th>
                                                        <th>休憩（分）</th>
                                                        <th>その他休憩（分）</th>
                                                        <th>深夜帯休憩（分）</th>
                                                        <th>修正フラグ</th>
                                                        <th>休暇タイプ</th>
                                                        <th>早出フラグ</th>
                                                        <th>勤務形態</th>
                                                        <th>備考</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(log, index) in result.workChangelogList" :key="index">
                                                        <td>{{log.modifiedDate | datetime}}</td>
                                                        <td>{{log.modifiedUserName}}</td>
                                                        <td>{{log.clockIn | datetime}}</td>
                                                        <td>{{log.clockOut | datetime}}</td>
                                                        <td>{{log.breakTimeMin}}</td>
                                                        <td>{{log.otherBreakTimeMin}}</td>
                                                        <td>{{log.midnightBreakTimeMin}}</td>
                                                        <td>{{log.edited}}</td>
                                                        <td>
                                                            <span v-if="log.dayOff == 0">なし</span>
                                                            <span v-if="log.dayOff == 1">半休</span>
                                                            <span v-if="log.dayOff == 2">全休</span>
                                                            <span v-if="log.dayOff == 3">特別休暇</span>
                                                            <span v-if="log.dayOff == 4">代休</span>
                                                            <span v-if="log.dayOff == 5">その他 諸定休暇</span>
                                                        </td>
                                                        <td>{{log.earlyShift ? '早出' : ''}}</td>
                                                        <td>{{log.workStyle}}</td>
                                                        <td>{{log.note}}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </td>
                        <!-- <td class="pt-0 pb-0 noflap"> -->
                        <td class="pt-0 pb-0 noflap" @mouseenter="tooltip(result.status, $event)" @mouseleave="closeTooltip">
                            <span v-if="result.status === '確定'" class="square_btn1">確定</span>
                            <!-- <span v-else-if="result.status === '承認済み'" class="badge-danger">承認済み</span> -->
                            <span v-else-if="result.status === '承認済み'" class="square_btn">承認</span>
                            <span v-else-if="result.status === '差し戻し依頼'" class="square_btn2">差戻し依頼</span>
                            <span v-else>
                                <button class="btn btn-default btn-sm btn-outline-info" @click="goEdit(result.targetDate)">修正</button>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
.noflap{
 white-space: nowrap;
}
.highlight{
 background: aliceblue;
}
.work-highlight {
 background: #F8F6CA;
}
.square_btn {
    display: inline-block;
    padding: 0.3em 1em;
    text-decoration: none;
    color: rgb(201, 22, 9);
    border: solid 1px rgb(201, 22, 9);
    border-radius: 5px;
    -webkit-border-radius: 5px;    /* Safari,Google Chrome用 */  
    -moz-border-radius: 5px; 
    transition: .4s;
}
.square_btn1 {
    display: inline-block;
    padding: 0.3em 1em;
    text-decoration: none;
    color: rgb(10, 95, 143);
    border: solid 1px rgb(10, 95, 143);
    border-radius: 5px;
    -webkit-border-radius: 5px;    /* Safari,Google Chrome用 */  
    -moz-border-radius: 5px; 
    transition: .4s;
}

.square_btn2 {
    display: inline-block;
    padding: 0.3em 1em;
    text-decoration: none;
    color: rgb(30, 44, 31);
    border: solid 1px rgb(30, 44, 31);
    border-radius: 5px;
    -webkit-border-radius: 5px;    /* Safari,Google Chrome用 */  
    -moz-border-radius: 5px; 
    transition: .4s;
}

</style>

<script>
import Vue from "vue";
import WindowStatePlugin from "../../../util/WindowStatePlugin";
Vue.use(WindowStatePlugin);

import moment from "moment";
import WorkMenu from "./WorkMenu.vue";
import Toast from '../../Toast.vue'

import CommonAPI from "../../../api/common-api.js";
import ConfigAPI from "../../../api/config-api.js";
import WorkAPI from "../../../api/work-api.js";
import WorkShiftAPI from "../../../api/shift-api.js";
import UserAPI from '../../../api/user-api'

export default {
  name: "work",
  components: {
    WorkMenu,
    Toast
  },
  data() {
    return {
      holidayDateList: [],
      yearList: [],
      shiftList: [],
      userList: [],
      workList: [],
      user: {},
      config: {},
      workTimetable: {},
      selectedYear: moment().format("YYYY"),
      selectedMonth: moment().format("M"),
      selectedUserId: null,
      selectedShiftId: 0,
      selectedInterval: 0,
      showAttachment: false,
      uploadFile: null,
      isExistsUpload: null,
    }
  },
  watch: {
  },
  mounted() {
      if (this.$route.query.year) {
          this.selectedYear = this.$route.query.year
      }
      if (this.$route.query.month) {
          this.selectedMonth = this.$route.query.month
      }
      this.selectedUserId = this.$route.params.userId;
      this.getHolidayDateList()
      this.getYearList()
      this.getShiftList()
      this.getUserList()
      this.getUser()
      this.getConfig()
  },
  methods: {
      // ==================================================
      // 祝日一覧取得
      // ==================================================
      getHolidayDateList () {
          CommonAPI.getHolidayDateList()
            .then(res => {
                this.holidayDateList = res
            })
      },
      // ==================================================
      // 年一覧取得
      // ==================================================
      getYearList () {
          WorkAPI.getYearList()
            .then(res => {
                this.yearList = res
            })
      },
      // ==================================================
      // ユーザリスト取得
      // ==================================================
      getUserList () {
      UserAPI.getUserList(this.selectedUserId)
          .then(res => {
              this.userList = res
          })
      },
      // ==================================================
      // シフト一覧
      // ==================================================
      getShiftList () {
        WorkShiftAPI.getShiftList()
            .then(res => {
                this.shiftList = res
            })
      },
      // ==================================================
      // 設定取得
      // ==================================================
      getConfig () {
        ConfigAPI.get()
            .then(res => {
                this.config = res
            })
      },
      // ==================================================
      // ユーザ取得
      // ==================================================
      getUser () {
        UserAPI.getUser(this.selectedUserId)
            .then(res => {
                this.user = res
                // シフト設定
                if (this.user.defaultWorkShiftId != null) {
                    this.selectedShiftId = this.user.defaultWorkShiftId
                }
                // 労働時間単位設定
                if (this.user.defaultWorkTimeInterval != null) {
                    this.selectedInterval = this.user.defaultWorkTimeInterval
                } else if (this.user.companyWorkTimeInterval != null) {
                    this.selectedInterval = this.user.companyWorkTimeInterval
                }
                // ユーザ取得後、勤務表取得
                this.getWorkTimetable()
                this.checkExistsUpload()
            })
      },
      // ==================================================
      // 勤務表取得
      // ==================================================
      getWorkTimetable () {
        this.$root.$refs.loading.$data.show = true
        let params = {}
        params['year'] = this.selectedYear
        params['month'] = this.selectedMonth
        params['userId'] = this.selectedUserId
        params['interval'] = this.selectedInterval
        params['shiftId'] = this.selectedShiftId
        WorkAPI.getWorkTimetable(params)
            .then(res => {
                this.workList = res.workMonthlyList
                this.workTimetable = res
                this.$nextTick(function() {
                    $(".close").click()
                    this.$root.$refs.loading.$data.show = false
                })
            })
            .catch(err => {
                this.$root.$refs.loading.$data.show = false
            })
      },
      // ==================================================
      // 祝日判定
      // ==================================================
      isHoliday (targetDate) {
          if (this.holidayDateList.indexOf(targetDate) >= 0) {
              return true
          } else {
              return false
          }
      },
      // ==================================================
      // ページ更新
      // ==================================================
      goWorkDetail () {
          this.$router.push(`/admin/work/detail/${this.selectedUserId}`)
          this.getWorkTimetable()
      },
      // ==================================================
      // 編集画面へ遷移
      // ==================================================
      goEdit (targetDate) {
          this.$router.push(`/admin/work/edit/${targetDate}/${this.selectedUserId}`)
      },
      // ==================================================
      // ステータス更新
      // ==================================================
      updateStatus (status) {
          this.$root.$refs.loading.$data.show = true
          WorkAPI.updateStatus(status, this.selectedYear, this.selectedMonth, this.selectedUserId)
            .then(res => {
                $(".close").click()
                this.$root.$refs.loading.$data.show = false
                this.getWorkTimetable()
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
      },
      // ==================================================
      // ハイライト設定
      // ==================================================
      highlight (column) {
          switch (column) {
            case 'clockIn':
                this.config.highlightTimeTableClockIn = this.config.highlightTimeTableClockIn == 0 ? 1 : 0
                break
            case 'clockOut':
                this.config.highlightTimeTableClockOut = this.config.highlightTimeTableClockOut == 0 ? 1 : 0
                break
            case 'breakTime':
                this.config.highlightTimeTableBreakTime = this.config.highlightTimeTableBreakTime == 0 ? 1 : 0
                break
            case 'otherBreakTime':
                this.config.highlightTimeTableOtherBreakTime = this.config.highlightTimeTableOtherBreakTime == 0 ? 1 : 0
                break
            case 'midnightBreakTime':
                this.config.highlightTimeTableMidnightBreakTime = this.config.highlightTimeTableMidnightBreakTime == 0 ? 1 : 0
                break
            case 'fixedTime':
                this.config.highlightTimeTableFixedTime = this.config.highlightTimeTableFixedTime == 0 ? 1 : 0
                break
            case 'overTime':
                this.config.highlightTimeTableOverTime = this.config.highlightTimeTableOverTime == 0 ? 1 : 0
                break
            case 'midnightTime':
                this.config.highlightTimeTableMidnightTime = this.config.highlightTimeTableMidnightTime == 0 ? 1 : 0
                break
            case 'workTime':
                this.config.highlightTimeTableWorkTime = this.config.highlightTimeTableWorkTime == 0 ? 1 : 0
                break
          }
        // DBを更新する
        ConfigAPI.update(this.config)
      },
      // ==================================================
      // セレクト変更時
      // ==================================================
      changeSelected () {
        // 履歴を追加
        this.$router.push(`/admin/work/detail/${this.selectedUserId}?year=${this.selectedYear}&month=${this.selectedMonth}&interval=${this.selectedInterval}&shiftId=${this.selectedShiftId}`)
        // データの再取得
        this.getWorkTimetable()
        this.checkExistsUpload()
      },
      // ==================================================
      // 添付ファイル確認
      // ==================================================
      checkExistsUpload() {
          WorkAPI.isExistsUpload(this.selectedYear, this.selectedMonth, this.selectedUserId)
              .then(res => {
                  this.isExistsUpload =  res.isExists;
              })
              .catch(err => {
                  console.error(err)
              })
      },
      // ==================================================
      // ファイル削除
      // ==================================================
      deleteAttachment() {
          if (window.confirm('削除しますか？')){
              this.$root.$refs.loading.$data.show = true
              WorkAPI.deleteFile(this.selectedYear, this.selectedMonth, this.selectedUserId)
                  .then(res => {
                      this.isExistsUpload = false
                      this.uploadFile = null
                      document.getElementById('uploadFile').value = ''
                      this.showAttachment = false
                      this.$root.$refs.loading.$data.show = false
                      this.$refs.toast.showToast("ファイルを削除しました", 3000, false)
                  })
                  .catch(err => {
                      console.error(err)
                      this.$root.$refs.loading.$data.show = false
                  })
          }
      },
      // ==================================================
      // ファイル選択開閉
      // ==================================================
      clickShowAttachment() {
          this.showAttachment = !this.showAttachment;
      },
      // ==================================================
      // ファイル選択
      // ==================================================
      selectedFile(e) {
          e.preventDefault();
          let files = e.target.files;
          this.uploadFile = files[0];
          this.isInvalidFile()
      },
      // ==================================================
      // ファイル検証
      // ==================================================
      isInvalidFile() {
          // サイズチェック
          if (this.uploadFile.size >= 2000000) {
              this.$refs.toast.showToast("※2MB以上のファイルはアップロードできません。", 3000, true)
              this.uploadFile = null
              document.getElementById('uploadFile').value = ''
              return true
          }
          // ファイルタイプチェック
          let splits =this.uploadFile.name.toLowerCase().split(".");
          let extension = splits[splits.length - 1];
          let allowExtension = ["pdf", "jpg", "jpeg", "png", "xls", "xlsx"];
          if (allowExtension.indexOf(extension) < 0){
              this.$refs.toast.showToast("※PDF/JPG/PNG/Excel以外のファイルはアップロードできません。", 3000, true)
              this.uploadFile = null
              document.getElementById('uploadFile').value = ''
              return true
          }
          return false
      },
      // ==================================================      
      // アップロード
      // ==================================================
      upload() {
          // バリデーション
          if(this.uploadFile == null || this.isInvalidFile()){
              return
          }
          this.$root.$refs.loading.$data.show = true
          let formData = new FormData();
          formData.append('file', this.uploadFile);
          WorkAPI.upload(this.selectedYear, this.selectedMonth, this.selectedUserId, formData)
              .then(res => {
                  this.isExistsUpload = true
                  this.uploadFile = null
                  this.showAttachment = false
                  document.getElementById('uploadFile').value = ''
                  this.$root.$refs.loading.$data.show = false
                  this.$refs.toast.showToast("ファイルをアップロードしました。", 3000, false)
              })
              .catch(err => {
                  this.$root.$refs.loading.$data.show = false
              })
      },
      // ==================================================
      // ツールチップ
      // ==================================================
      tooltip(status, e) {
          switch (status) {
                case '確定':
                    this.$root.$refs.tooltip.showTooltip(e,"勤怠は確定しています。\n管理者の承認待ちです。")
                    break;
                case '承認済み':
                    this.$root.$refs.tooltip.showTooltip(e,"勤怠が承認済みです。")
                    break;
                case '差し戻し依頼':
                    this.$root.$refs.tooltip.showTooltip(e,"差し戻し依頼があります。\n差し戻しを承認する場合は差し戻しボタンを押してください。")
                    break;
          }
      },
      // ==================================================
      // ツールチップ非表示
      // ==================================================
      closeTooltip(e) {
          this.$root.$refs.tooltip.close()
      },
      // ==================================================
      // 退職済みか
      // ==================================================
      isRetiree(deletedAt){
          if(deletedAt){
            var ym = moment().set('year', this.selectedYear).set('month', this.selectedMonth - 1).set('date', 1).format("YYYY-MM-DD")
            return moment(deletedAt).isBefore(ym)
          }
          return false
      }
  },
  filters: {
    datetime: function (data) {
      return data ? moment(data).format("YYYY年MM月DD日 HH:mm") : ''
    },
    date: function (data) {
      return data ? moment(data).format("MM/DD") : ''
    },
    time: function (data) {
      return data ? moment(data).format("HH:mm") : ''
    }
  }
  
}
</script>




// WEBPACK FOOTER //
// src/assets/js/components/admin/work/WorkDetail.vue